




























import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
// 组件
import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
import DataBoard from "./components/DataBoard.vue";

// 混入
import Loading from "@/mixins/loading";
// 工具
import debounce from "@/utils/debounce";

@Component({
  components: {
    DataBoard,
    Table,
    Header,
  },
})
export default class Vip extends Mixins(Loading) {
  fromDate: string = ""; // 日期
  shopName: string = ""; // 企业名称
  phone: string = ""; // 手机号码
  userName: string = ""; // 客户名称
  status: string = ""; // 审核状态

  /**
   * 监听
   */
  @Watch("fromDate")
  @Watch("shopName")
  @Watch("phone")
  @Watch("userName")
  @Watch("status")
  searchValue() {
    debounce(() => this.handleSearch());
  }

  // 搜索
  handleSearch() {
    let table: any = this.$refs.table;
    table.getData();
  }
  // 输入
  inputValue(val: string, type: string) {
    let self: any = this;
    self[type] = val;
  }
  // 输入
  updateStatueValue(val: string) {
    this.status = val;
    console.log(val)
    let table: any = this.$refs.table;
    table.getData();
  }
}
